import {
  signIn as amplifySignIn,
  signOut as amplifySignOut,
  signUp as amplifySignUp,
  updatePassword as amplifyUpdatePassword,
  confirmResetPassword,
  confirmSignIn,
  confirmSignUp,
  fetchAuthSession,
  fetchUserAttributes,
  getCurrentUser,
  resetPassword,
  signInWithRedirect,
} from "aws-amplify/auth";
import type {
  ChangePasswordParameters,
  CompleteNewPasswordParameters,
  SendPasswordResetEmailParameters,
  SignInParameters,
  SignUpParameters,
  UpdatePasswordParameters,
  VerifyEmailAddressParameters,
} from "./types";

const signInWithGoogle = () => {
  return signInWithRedirect({ provider: "Google" });
};

const signUp = ({ emailAddress, password }: SignUpParameters) => {
  return amplifySignUp({
    username: emailAddress,
    password,
    options: {
      userAttributes: {
        email: emailAddress,
      },
    },
  });
};

const verifyEmailAddress = ({ emailAddress, verificationCode }: VerifyEmailAddressParameters) => {
  return confirmSignUp({ username: emailAddress, confirmationCode: verificationCode });
};

const signIn = ({ emailAddress, password }: SignInParameters) => {
  return amplifySignIn({ username: emailAddress, password });
};

const signOut = () => {
  return amplifySignOut();
};

const getAuthenticatedUser = () => {
  return getCurrentUser();
};

const getAuthenticatedUserAttributes = () => {
  return fetchUserAttributes();
};

const getCurrentSession = () => {
  return fetchAuthSession();
};

const sendPasswordResetEmail = ({ emailAddress }: SendPasswordResetEmailParameters) => {
  return resetPassword({ username: emailAddress });
};

const changePassword = ({ emailAddress, verificationCode, newPassword }: ChangePasswordParameters) => {
  return confirmResetPassword({
    username: emailAddress,
    confirmationCode: verificationCode,
    newPassword,
  });
};

const updatePassword = ({ currentPassword, newPassword }: UpdatePasswordParameters) => {
  return amplifyUpdatePassword({ oldPassword: currentPassword, newPassword });
};

const completeNewPassword = ({ password }: CompleteNewPasswordParameters) => {
  return confirmSignIn({ challengeResponse: password });
};

export const authenticationService = {
  signInWithGoogle,
  signUp,
  verifyEmailAddress,
  signIn,
  signOut,
  getAuthenticatedUser,
  getAuthenticatedUserAttributes,
  getCurrentSession,
  sendPasswordResetEmail,
  changePassword,
  updatePassword,
  completeNewPassword,
};
